<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-09-08 11:00:32
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-12 11:52:31
 * @FilePath: \partner.chaoyongtuan.com\src\views\cooperationProgress\list\components\cardList\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<yxCardList>
		<el-checkbox-group v-model="checkedItem" @change="handleCheckedChange">
			<yxCardItem v-for="(row, index) in list" :key="index" class="mt-16">
				<div class="flex flex-align-center" slot="header">
					<el-tooltip :content="row.activityTitle" placement="top" v-ak-tooltip-auto-show>
						<p class="line-ellipsis-1 yx-color-text-primary font-h4-medium" style="max-width: 500px">{{ row.activityTitle }}</p>
					</el-tooltip>
					<plainTag class="ml-4" :type="row.activityType === 1 ? 'default' : 'primary'">
						{{ row.activityType === 1 ? '普通招商' : '专属招商' }}
					</plainTag>
				</div>
				<div style="width: 238px" class="pr-12 font-h6-regular">
					<p>
						<span class="yx-color-text-secondary">活动ID：</span>
						<span class="yx-color-text-primary">{{ row.activityId }}</span>
					</p>
				</div>
				<div class="font-h6-regular yx-color-text-primary">
					<p class="flex-row-align-center">
						<span class="nowarp">团长：</span>
						<el-tooltip :content="row.activityUserNickName" placement="top" v-ak-tooltip-auto-show>
							<span class="line-ellipsis-1" style="width: 100%">{{ row.activityUserNickName }}</span>
						</el-tooltip>
					</p>
					<p>
						<span class="yx-color-text-secondary">快手ID：</span>
						<span class="yx-color-text-primary">{{ row.activityUserId }}</span>
					</p>
				</div>
				<div class="font-h6-regular">
					<p class="yx-color-text-primary">{{ row.minItemCommissionRate }}%</p>
					<p class="yx-color-text-secondary">最低佣金</p>
				</div>
				<div class="font-h6-regular">
					<p class="yx-color-text-primary">{{ row.minInvestmentPromotionRate }}%</p>
					<p class="yx-color-text-secondary">服务费</p>
				</div>
				<div class="font-h6-regular">
					<p class="yx-color-text-primary">{{ row.activityEndTime | formatDate }}</p>
					<p class="yx-color-text-secondary">报名截止</p>
				</div>
				<div class="right flex-row-align-center flex-just-end" v-if="$auth.hasPermi('system:colonelActivitySquare:Registered')">
					<el-button @click="signUp(row)">立即报名</el-button>
				</div>
			</yxCardItem>
		</el-checkbox-group>
	</yxCardList>
</template>
<script>
import yxCardList from '@/components/ui/yxCardList';
import yxCardItem from '@/components/ui/yxCardItem';
import { todayCheck } from '@/utils/validate';
import plainTag from '@/components/ui/plainTag';
import { PLATFORM_KS } from '@/utils/dataMap';
export default {
	components: {
		yxCardList,
		yxCardItem,
		plainTag,
	},
	props: {
		list: {
			type: Array,
			default: () => [],
		},
		selectedList: {
			type: Array,
			default: () => [],
		},
	},
	watch: {
		selectedList: {
			handler: function (val) {
				this.checkedItem = val;
			},
			deep: true,
		},
	},
	data() {
		return {
			checkedItem: [],
		};
	},
	methods: {
		// 选中单个
		handleCheckedChange(value) {
			let checkedCount = value.length;
			if (checkedCount === this.list.length) {
				this.$emit('changeData', 'allChecked', true);
			}
			this.$emit('changeData', 'isIndeterminate', Number(checkedCount) > 0 && Number(checkedCount) < this.list.length);
			this.checkedItemFn(value);
		},
		// 传出选中信息用于批量操作
		checkedItemFn(val) {
			this.$emit('checkedItemFn', val);
		},
		signUp({ activityId, authorityId: authority_id }) {
			let handLink = this.$router.resolve({
				path: '/secondColonelManage/colonelActivitySquare/detail',
				query: {
					id: activityId,
					signUp: '0',
					platformId: PLATFORM_KS.value,
					authority_id,
				},
			});
			window.open(handLink.href, '_blank');
		},
	},
};
</script>
<style lang="less" scoped>
.right {
	/deep/ .el-button {
		color: @color-primary !important;
	}

	/deep/ .default {
		color: #cccccc !important;
	}
}
.recommend {
	margin-left: 10px;
	font-size: 12px;
	padding: 0px 8px;
	border-radius: 4px;
	height: 18px;
	line-height: 18px;
	color: #fff;
	background-color: @color-primary;
}

.activity-desc-tooltip {
	max-width: 300px;
}
</style>
